import React from "react";
import { Pagination, PopUp } from "../../components";
import { Table } from "./PenfastPatientsHospitalPresentTable";
import { PenfastPatientsHospitalPresentLogic } from "./PenfastPatientsHospitalPresentLogic";
import { Legend } from "./Legend";

export const PenfastPatientsHospitalPresent = ({ careType, ...props }) => {
  const {
    error,
    table,
    columns,
    options,
    onPaginate,
    togglePopup,
    paramsState,
    findPatients,
    filter,
    handleFilterChange,
    handleCheckboxFilterChange,
    handleDateChange,
    handleResetFilter,
  } = PenfastPatientsHospitalPresentLogic(careType);

  return (
    <>
      <div className="penfast-hospital">
        <div className="max-w-auto">
          <div className="myContent">
            {error.error && (
              <PopUp toggle={togglePopup} message={error.message} />
            )}
            <div className="container-fluid">
              <div className="col-xl-8 col-lg-12">
                <div className="row">
                  <FilterCheckbox
                    value={filter.current_penfast_score_is_0_or_null}
                    name="current_penfast_score_is_0_or_null"
                    onChange={handleCheckboxFilterChange}
                    label="PF skóre 0 + N"
                  />
                  <FilterCheckbox
                    value={filter.current_penfast_score_is_1_2}
                    name="current_penfast_score_is_1_2"
                    onChange={handleCheckboxFilterChange}
                    label="PF skóre 1 - 2"
                  />
                  <FilterCheckbox
                    value={filter.current_penfast_score_is_3_5}
                    name="current_penfast_score_is_3_5"
                    onChange={handleCheckboxFilterChange}
                    label="PF skóre 3 - 5"
                  />
                </div>
              </div>
            </div>
            <div className="form-row-button" style={{ paddingBottom: 10 }}>
              <button
                type="submit"
                className="button"
                disabled={table.loading}
                onClick={findPatients}
              >
                Vyhledat
              </button>
            </div>

            <div className="grid-row">
              <div className="container-fluid">
                <div className="row">
                  {/* Results */}
                  {table.loading ? (
                    <div className="col-12">
                      <h2>Načítání...</h2>
                    </div>
                  ) : (
                    <>
                      <div className="col-12">
                        <Legend />
                      </div>
                      <div className="col-12">
                        <Table
                          data={table.data}
                          columns={columns[careType]}
                          options={options}
                          id={"penfast"}
                          filter={filter}
                          careType={careType}
                          handleFilterChange={handleFilterChange}
                          handleDateChange={handleDateChange}
                          handleResetFilter={handleResetFilter}
                          onSubmit={findPatients}
                        />
                      </div>
                      <div className="col-12">
                        <Pagination
                          onSubmit={onPaginate}
                          pagination={table.pagination}
                          paramsState={paramsState}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FilterCheckbox = (props) => {
  const { value, name, onChange, label } = props;
  return (
    <div className="col-xl-4 col-md-6 col-sm-12 mb-2">
      <div
        style={{
          display: "flex",
          msFlexDirection: "row",
          justifyItems: "center",
        }}
      >
        <input
          className="styled-checkbox"
          id={name}
          type="checkbox"
          checked={value}
          onChange={() => onChange(name)}
        />
        <label className="ml-3" htmlFor={name}>
          {label}
        </label>
      </div>
    </div>
  );
};
